import React from 'react';
import { Modal, Button, Form, Badge } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

const EstadoModal = ({ show, onHide, tipoEstadoNombre = '', loading = false, onSave = () => {} }) => {
  // Form state
  const [formData, setFormData] = React.useState({
    estado: '',
    descripcion: ''
  });

  // Reset form on open
  React.useEffect(() => {
    if (show) {
      setFormData({ estado: '', descripcion: '' });
    }
  }, [show]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal show={show} onHide={onHide} size="md" backdrop="static" keyboard={false}>
      <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
        <Modal.Title style={{ display: 'flex', alignItems: 'center', color: '#495057' }}>
          <FaIcons.FaPlus style={{ marginRight: '12px', color: '#6c757d' }} />
          Crear Nuevo Estado
        </Modal.Title>
      </Modal.Header>
      <Form>
        {/* Tipo de Estado */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          background: '#f4f8fb',
          borderRadius: 8,
          padding: '12px 20px 4px 20px',
          marginBottom: 0,
          border: '1px solid #e3e8ee',
          fontSize: '1.15rem',
          fontWeight: 600,
          color: '#495057',
          gap: 12
        }}>
          <FaIcons.FaLayerGroup style={{ fontSize: '1.3rem', color: '#17a2b8' }} />
          <span style={{ marginRight: 8 }}>Tipo de Estado:</span>
          <Badge bg="info" style={{ fontSize: '1.1rem', padding: '7px 18px', borderRadius: 6, letterSpacing: 1 }}>{tipoEstadoNombre}</Badge>
        </div>
        <Modal.Body style={{ padding: '24px' }}>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontWeight: '600', color: '#495057' }}>
              <FaIcons.FaTag style={{ marginRight: '8px' }} />
              Nombre del Estado *
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Ej: Recepcionado, En Proceso, Finalizado..."
              value={formData.estado}
              onChange={e => handleInputChange('estado', e.target.value)}
              maxLength={100}
              disabled={loading}
            />
            <Form.Text className="text-muted">Máximo 100 caracteres</Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontWeight: '600', color: '#495057' }}>
              <FaIcons.FaAlignLeft style={{ marginRight: '8px' }} />
              Descripción *
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Describe brevemente el propósito de este estado..."
              value={formData.descripcion}
              onChange={e => handleInputChange('descripcion', e.target.value)}
              maxLength={255}
              disabled={loading}
            />
            <Form.Text className="text-muted">Máximo 255 caracteres ({formData.descripcion.length}/255)</Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: '#f8f9fa', borderTop: '2px solid #dee2e6' }}>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            <FaIcons.FaTimes style={{ marginRight: '8px' }} />
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={!formData.estado || loading} onClick={handleSubmit}>
            <FaIcons.FaPlus style={{ marginRight: '8px' }} />
            Crear Estado
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EstadoModal;
